import { render, staticRenderFns } from "./ResourceSelect.vue?vue&type=template&id=79747de5"
import script from "./ResourceSelect.vue?vue&type=script&lang=js"
export * from "./ResourceSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports